import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { fmtEur } from "../pages/Boutique";
import { ShoppingBag, Loader2, Store } from "lucide-react";

const STATUS = {
  to_prepare: { label: "En préparation", cls: "bg-amber-50 text-amber-700" },
  ready: { label: "Prête à retirer", cls: "bg-sky-50 text-sky-700" },
  delivered: { label: "Retirée", cls: "bg-emerald-50 text-emerald-700" },
  canceled: { label: "Annulée", cls: "bg-stone-100 text-stone-500" },
};

const ParentShopOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/parent/shop/my-orders")
      .then(({ data }) => setOrders(data || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="parent-shop-orders">
      <h1 className="font-serif-display text-2xl sm:text-3xl text-stone-800 flex items-center gap-2 mb-1"><ShoppingBag size={22} /> Mes commandes boutique</h1>
      <p className="text-stone-500 text-sm mb-6">Vos achats de goodies, à retirer à l&apos;école.</p>

      {loading ? (
        <div className="py-12 text-center text-stone-400"><Loader2 className="animate-spin inline" size={20} /></div>
      ) : orders.length === 0 ? (
        <div className="bg-white rounded-2xl p-8 text-center">
          <Store size={28} className="mx-auto text-stone-300 mb-3" />
          <p className="text-stone-500 italic mb-5">Aucune commande pour le moment.</p>
          <Link to="/boutique" className="inline-block bg-coral text-white px-6 py-3 rounded-full text-sm tracking-widest uppercase">Découvrir la boutique</Link>
        </div>
      ) : (
        <div className="space-y-3">
          {orders.map((o) => {
            const st = STATUS[o.status] || STATUS.to_prepare;
            return (
              <div key={o.id} className="bg-white rounded-2xl p-4" data-testid={`parent-shop-order-${o.orderNumber}`}>
                <div className="flex items-start justify-between gap-3 flex-wrap">
                  <div>
                    <div className="font-medium text-stone-800">{o.orderNumber}</div>
                    <div className="text-xs text-stone-500">{(o.paidAt || o.createdAt || "").slice(0, 10)}</div>
                  </div>
                  <span className={`text-xs px-2.5 py-1 rounded-full ${st.cls}`}>{st.label}</span>
                </div>
                <ul className="mt-3 text-sm text-stone-600 space-y-0.5">
                  {(o.items || []).map((i, idx) => (
                    <li key={idx}>{i.qty}× {i.name}{[i.size, i.color].filter(Boolean).length ? ` (${[i.size, i.color].filter(Boolean).join(" · ")})` : ""}</li>
                  ))}
                </ul>
                <div className="mt-3 pt-3 border-t border-stone-100 text-sm flex justify-between">
                  <span className="text-stone-500">Total réglé</span>
                  <span className="text-deep-rose font-medium">{fmtEur(o.total)}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ParentShopOrders;
